// useCurriculumTabsABPContentHandlers.ts
import * as React from "react";

type Especialidad = { id: string; nombre: string };
type SimpleIdNombre = { id: string; nombre: string };

type Args = {
  // TP
  setEspecialidad: React.Dispatch<React.SetStateAction<Especialidad | null>>;
  clearTP: () => void;
  handleNivelTPChange: (nivel: any) => void;
  handleAsignaturaTPChangeLocal: (a: { id: string; nombre: string }) => void;

  // ORG
  setNivelOrg: React.Dispatch<React.SetStateAction<SimpleIdNombre>>;
  setAsignaturaOrg: React.Dispatch<React.SetStateAction<SimpleIdNombre>>;
  emptyIdNombre: SimpleIdNombre;

  // Shared state updaters
  setPromptData: React.Dispatch<React.SetStateAction<any>>;
  setProyecto: React.Dispatch<React.SetStateAction<any>>;
};

export function useCurriculumTabsABPContentHandlers({
  setEspecialidad,
  clearTP,
  handleNivelTPChange,
  handleAsignaturaTPChangeLocal,
  setNivelOrg,
  setAsignaturaOrg,
  emptyIdNombre,
  setPromptData,
  setProyecto,
}: Args) {
  const onEspecialidadChange = React.useCallback(
    (esp: Especialidad) => {
      setEspecialidad(esp);
      clearTP();
    },
    [setEspecialidad, clearTP]
  );

  const onTPNivelChange = React.useCallback(
    (nivel: any) => {
      handleNivelTPChange(nivel);
      setPromptData((prev: any) => ({
        ...prev,
        nivel: nivel?.nombre ?? "",
      }));
      setProyecto((prev: any) => ({
        ...prev,
        nivel_curso_cn: "",
        nivel_curso_org: "",
        nivel_curso_tp: nivel.nombre,
      }));
    },
    [handleNivelTPChange, setPromptData]
  );

  const onTPAsignaturaChange = React.useCallback(
    (a: { id: string; nombre: string }) => {
      handleAsignaturaTPChangeLocal(a);
    
      setProyecto((prev: any) => {
      const prevTp: string[] = Array.isArray(prev?.materias_tp) ? prev.materias_tp : [];
      const nombre = a?.nombre ?? "";
      return {
        ...prev,
        materias_cn: [],
        materias_org: [],
        materias_tp: nombre && !prevTp.includes(nombre) ? [...prevTp, nombre] : prevTp,
      };
    });
    },
    [handleAsignaturaTPChangeLocal, setPromptData, setProyecto]
  );

  const onOrgNivelChange = React.useCallback(
    (id: any, nombre: any) => {
      const next = { id: String(id ?? ""), nombre: String(nombre ?? "") };

      setNivelOrg(next);
      setAsignaturaOrg(emptyIdNombre);

      setPromptData((prev: any) => ({
        ...prev,
        nivel: next.nombre,
      }));

      setProyecto((prev: any) => ({
        ...prev,
        nivel_curso_org: next.nombre,
        nivel_curso_cn: prev.nivel_curso_cn || "",
        nivel_curso_tp: ""
      }));
    },
    [setNivelOrg, setAsignaturaOrg, emptyIdNombre, setPromptData, setProyecto]
  );

  const onOrgAsignaturaChange = React.useCallback(
    (a: { id: string; nombre: string }) => {
      setAsignaturaOrg({ id: a.id, nombre: a.nombre });
     setProyecto((prev: any) => {
      const prevTp: string[] = Array.isArray(prev?.materias_org) ? prev.materias_org : [];
      const nombre = a?.nombre ?? "";
      return {
        ...prev,
        materias_cn: prev.materias_cn || [] ,
        materias_tp: [],
        materias_org: nombre && !prevTp.includes(nombre) ? [...prevTp, nombre] : prevTp,
      };
    });
    },
    [setAsignaturaOrg, setPromptData]
  );

  return {
    onEspecialidadChange,
    onTPNivelChange,
    onTPAsignaturaChange,
    onOrgNivelChange,
    onOrgAsignaturaChange,
  };
}
